// extracted by mini-css-extract-plugin
export var askAiIcon = "_mo-j";
export var category = "_mo-9";
export var categoryHeader = "_mo-e";
export var container = "_mo-0";
export var group = "_mo-a";
export var groupItems = "_mo-f";
export var groupSeparator = "_mo-k";
export var loading = "_mo-1";
export var noResults = "_mo-3";
export var placeholder = "_mo-2";
export var resultContent = "_mo-5";
export var resultIcon = "_mo-c";
export var resultItem = "_mo-g";
export var resultMeta = "_mo-8";
export var resultSubtitle = "_mo-7";
export var resultSuffix = "_mo-i";
export var resultTitle = "_mo-6";
export var resultsList = "_mo-4";
export var searchGroup = "_mo-d";
export var selected = "_mo-h";
export var subgroup = "_mo-b";